import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TablePagination from "@material-ui/core/TablePagination";
import DatePicker from "react-datepicker";
import { getSorting, getNumberSorting } from "../components/Utils";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import {
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
  DRAWER_WIDTH,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import CustomTableHead from "../components/CustomTableHead";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Portal } from "react-overlays";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",
    position: "fixed",
    top: `${MAIN_CONTENT_TOP + 50}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  progress: {
    margin: theme.spacing.unit,
  },
});

const columnData1 = [
  { id: "usrId", numeric: false, disablePadding: true, label: "User ID" },
  { id: "usrName", numeric: false, disablePadding: true, label: "User" },
  { id: "realm", numeric: false, disablePadding: true, label: "Realm" },
  { id: "event", numeric: false, disablePadding: true, label: "Event" },
  { id: "desc", numeric: false, disablePadding: true, label: "Description" },
  { id: "date", numeric: false, disablePadding: true, label: "Time" },
];

const columnData2 = [
  { id: "usrName", numeric: false, disablePadding: true, label: "User" },
  { id: "date", numeric: false, disablePadding: true, label: "Date" },
  { id: "event", numeric: false, disablePadding: true, label: "Event" },
  { id: "desc", numeric: false, disablePadding: true, label: "Description" },
];

const columnData3 = [
  { id: "usrName", numeric: false, disablePadding: true, label: "User" },
  { id: "oType", numeric: false, disablePadding: true, label: "Object Type" },
  { id: "oName", numeric: false, disablePadding: true, label: "Object Name" },
  { id: "oValue", numeric: false, disablePadding: true, label: "Object Value" },
  { id: "oRight", numeric: false, disablePadding: true, label: "Rights" },
  { id: "create", numeric: false, disablePadding: true, label: "Created On" },
  {
    id: "modify",
    numeric: false,
    disablePadding: true,
    label: "Last Modified",
  },
];

const columnData4 = [
  { id: "usrName", numeric: false, disablePadding: true, label: "User" },
  { id: "date", numeric: false, disablePadding: true, label: "Date Changed" },
  { id: "bankId", numeric: false, disablePadding: true, label: "Bank ID" },
  { id: "usrId", numeric: false, disablePadding: true, label: "User ID" },
  { id: "oType", numeric: false, disablePadding: true, label: "Object Type" },
  { id: "oName", numeric: false, disablePadding: true, label: "Object Name" },
  { id: "oValue", numeric: false, disablePadding: true, label: "Object Value" },
  { id: "oRight", numeric: false, disablePadding: true, label: "Old Rights" },
  { id: "nRight", numeric: false, disablePadding: true, label: "New Rights" },
  {
    id: "userChanged",
    numeric: false,
    disablePadding: true,
    label: "User Changing",
  },
];

class UserReportsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      items: [],
      order: "asc",
      orderBy: "0",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      canSearch: false,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      viewPdf: false,
      selectedReport: "1",
      selectedUser: "0",
      searchReportInProgress: false,
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleReportChange(e) {
    this.disableSearch();
    this.setState({ selectedReport: e.target.value });
  }

  handleUser(e) {
    this.disableSearch();
    this.setState({ selectedUser: e.target.value });
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ searchReportInProgress: false });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ searchReportInProgress: true });
    this.setState({ page: 0 });
    this.setState({ orderBy: "" });
    this.setState({ canSearch: true });
    this.search(0, this.state.rowsPerPage, false);
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  validateDates() {
    if (this.state.selectedReport !== "3") {
      let start = this.state.startDate;
      let end = this.state.endDate;
      if (start !== null && end !== null && end.isBefore(start, "day")) {
        this.setState({
          errorString: getErrorString(
            "general.error.endDate",
            "End Date is before Start Date"
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
    }
    return true;
  }

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      this.search(0, e.target.value, true);
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      this.search(page, this.state.rowsPerPage, true);
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (orderBy === "usrId" || orderBy === "event") {
        data.sort(getNumberSorting(order, orderBy));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ searchReportInProgress: false });
  }

  getCriteriaObject() {
    let data = {
      r: new Date().getTime(),
      secureToken: this.props.secureToken,
      option: this.state.selectedReport,
      userId: this.state.selectedUser,
      page: this.state.page,
      rowsPerPage: this.state.rowsPerPage,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
    };
    return data;
  }

  search(page, rowsPerPage, sortIt) {
    fetch("on__user_report", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        option: this.state.selectedReport,
        userId: this.state.selectedUser,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        page: page,
        rowsPerPage: rowsPerPage,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else {
          this.setState({ searchReportInProgress: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            let items = reply.items;
            if (sortIt) {
              this.sort(this.state.orderBy, this.state.order, items);
            }
            this.setState({ items: items });
            this.setState({ totalCount: reply.totalCount });
            if (reply.totalCount === 0) {
              this.setState({ viewPopup: true });
              this.setState({
                notifyString: getErrorString(
                  "general.info.search.empty",
                  "Total number of items is 0."
                ),
              });
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ searchReportInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const { order, orderBy, rowsPerPage, page, totalCount } = this.state;
    const datePickerTopMargin = 10;
    const actionTopMargin = 4;
    let data = this.state.items;
    let options = this.props.users;
    return (
      <div className={classes.tableWrapper}>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            page={page}
            rowsPerPage={rowsPerPage}
            postData={this.getCriteriaObject()}
            pdfUrl="on__user_pdf_report"
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}

        <div>
          <Paper elevation={5}>
            <FormGroup row>
              <div>
                <Typography variant="caption">
                  {t("userReport.label")}&nbsp;&nbsp;
                </Typography>
                <FormControl>
                  <NativeSelect
                    style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                    defaultValue={this.state.selectedReport}
                    input={<Input id="report_options" />}
                    onChange={(event) => this.handleReportChange(event)}
                  >
                    <option value="1">{t("access.label")}</option>
                    <option value="2">{t("violations.label")}</option>
                    <option value="3">{t("userP.label")}</option>
                    <option value="4">{t("userPC.label")}</option>
                    <option value="5">{t("application.label")}</option>
                  </NativeSelect>
                </FormControl>
                &nbsp;&nbsp;
              </div>
              <div>
                <Typography variant="caption">
                  {t("userScope.label")}&nbsp;&nbsp;
                </Typography>
                <FormControl>
                  <NativeSelect
                    style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                    defaultValue={this.state.selectedUser}
                    input={<Input id="user_options" />}
                    onChange={(event) => this.handleUser(event)}
                  >
                    <option value="0">All Users</option>
                    {options.map((n) => {
                      return <option value={n.id}>{n.name}</option>;
                    })}
                  </NativeSelect>
                </FormControl>
                &nbsp;&nbsp;
              </div>
              {this.state.selectedReport !== "3" && (
                <div>
                  <Typography variant="caption">
                    {t("startDate.label")}
                    {!this.state.redrawStartDate && (
                      <div style={{ marginTop: datePickerTopMargin }}>
                        <DatePicker
                          isClearable
                          disabledKeyboardNavigation
                          dateFormat="LL"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={this.state.startDate}
                          onChange={(event) => this.handleStartDate(event)}
                          onClickOutside={(event) =>
                            this.handleStartDateOutsideClick(event)
                          }
                          popperContainer={CalendarContainer}
                        />
                      </div>
                    )}
                  </Typography>
                </div>
              )}
              &nbsp;&nbsp;
              {this.state.selectedReport !== "3" && (
                <div>
                  <Typography variant="caption">
                    {t("endDate.label")}
                    {!this.state.redrawEndDate && (
                      <div style={{ marginTop: datePickerTopMargin }}>
                        <DatePicker
                          isClearable
                          disabledKeyboardNavigation
                          dateFormat="LL"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={this.state.endDate}
                          onChange={(event) => this.handleEndDate(event)}
                          onClickOutside={(event) =>
                            this.handleEndDateOutsideClick(event)
                          }
                          popperContainer={CalendarContainer}
                        />
                      </div>
                    )}
                  </Typography>
                  &nbsp;&nbsp;
                </div>
              )}
              <Button
                color="primary"
                style={{ marginTop: actionTopMargin }}
                onClick={(event) => this.handleSearch(event)}
              >
                <SearchIcon />
                &nbsp;{t("search.button")}
              </Button>
              <Button
                color="primary"
                style={{ marginTop: actionTopMargin }}
                onClick={(event) => this.handlePdf(event)}
              >
                <PDFViewIcon />
                &nbsp;{t("pdf.button")}
              </Button>
            </FormGroup>
          </Paper>
          <Divider />
          {this.state.totalCount === 0 &&
            this.state.errorString.length === 0 &&
            this.state.searchReportInProgress && (
              <div>
                <CircularProgress className={classes.progress} />
              </div>
            )}
          <TablePagination
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event)}
            ActionsComponent={CustomPaginatorActions}
          />
          {this.state.canSearch && this.state.totalCount > 0 && (
            <Paper elevation={5}>
              {this.state.selectedReport === "1" && (
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData1}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data.map((n) => {
                      return (
                        <TableRow>
                          <TableCell>{n.usrId}</TableCell>
                          <TableCell>{n.usrName}</TableCell>
                          <TableCell>{n.realm}</TableCell>
                          <TableCell>{n.event}</TableCell>
                          <TableCell>{n.desc}</TableCell>
                          <TableCell>{n.date}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
              {(this.state.selectedReport === "2" ||
                this.state.selectedReport === "5") && (
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData2}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data.map((n) => {
                      return (
                        <TableRow>
                          <TableCell>{n.usrName}</TableCell>
                          <TableCell>{n.date}</TableCell>
                          <TableCell>{n.event}</TableCell>
                          <TableCell>{n.desc}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
              {this.state.selectedReport === "3" && (
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData3}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data.map((n) => {
                      return (
                        <TableRow>
                          <TableCell>{n.usrName}</TableCell>
                          <TableCell>{n.oType}</TableCell>
                          <TableCell>{n.oName}</TableCell>
                          <TableCell>{n.oValue}</TableCell>
                          <TableCell>{n.oRight}</TableCell>
                          <TableCell>{n.create}</TableCell>
                          <TableCell>{n.modify}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
              {this.state.selectedReport === "4" && (
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData4}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data.map((n) => {
                      return (
                        <TableRow>
                          <TableCell>{n.usrName}</TableCell>
                          <TableCell>{n.date}</TableCell>
                          <TableCell>{n.bankId}</TableCell>
                          <TableCell>{n.usrId}</TableCell>
                          <TableCell>{n.oType}</TableCell>
                          <TableCell>{n.oName}</TableCell>
                          <TableCell>{n.oValue}</TableCell>
                          <TableCell>{n.oRight}</TableCell>
                          <TableCell>{n.nRight}</TableCell>
                          <TableCell>{n.userChanged}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
            </Paper>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(UserReportsPage));
